// extracted by mini-css-extract-plugin
export default {"external":"aUXQn7","text":"bUXQn7","hint":"cUXQn7","iconFill":"dUXQn7","arrow":"eUXQn7"};